import JSEditor from './CodeEditor/JSEditor';
import CSSEditor from './CodeEditor/CSSEditor';
import Orientation from './Orientation';
import InchesInput from './InchesInput';
import CustomSelect from './CustomSelect';
import CustomCheckbox from './CustomCheckbox';
import CustomTextInput from './CustomTextInput';
import UnitSelectorWidget from './UnitSelectorWidget';
import ColorPicker from './ColorPicker';
import VerticalAlignment from './VerticalAlignment';
import HorizontalAlignment from './HorizontalAlignment';
import Slider from './Slider';
import UnitSelectorWithIcon from './UnitSelectorWithIcon';
import BoxModelProperties from './BoxModelProperties';
import Shadow from './Shadow';
import DisplayOption from './DisplayOption';
import FillSpaceProperty from './FillSpaceProperty';
import FlexDirectionProperty from './FlexDirectionProperty';
import ItemHorizontalAlign from './ItemHorizontalAlign';
import ItemVerticalAlign from './ItemVerticalAlign';
import ResourcePicker from './ResourcePicker';
import ThemeColorPicker from './ThemeColorPickerWidget';
import ThemeSelect from './ThemeSelect';
import PaletteSelect from './PaletteSelect';
import ShowDataButton from './ShowDataButton';
import SelectFundsButton from './SelectFundsButton';
import TypographyClassSelect from './TypographyClassSelect';
import MediaPicker from './MediaPicker';
import FontFamilySelect from './FontFamilySelect';
import FormDataMultiSelect from './FormDataMultiSelect';
import WidthModelProperties from './WidthModelProperties';
import SelectedFundsDropdown from './SelectedFundsDropdown';
import RichTextEditableWidget from './RichTextEditableWidget';

const Widgets: any = {
    JSEditor,
    CSSEditor,
    Orientation,
    InchesInput,
    CustomSelect,
    CustomCheckbox,
    CustomTextInput,
    UnitSelectorWidget,
    ColorPicker,
    VerticalAlignment,
    HorizontalAlignment,
    Slider,
    UnitSelectorWithIcon,
    BoxModelProperties,
    Shadow,
    DisplayOption,
    FillSpaceProperty,
    FlexDirectionProperty,
    ItemHorizontalAlign,
    ItemVerticalAlign,
    ResourcePicker,
    ThemeColorPicker,
    ThemeSelect,
    PaletteSelect,
    ShowDataButton,
    TypographyClassSelect,
    MediaPicker,
    FontFamilySelect,
    FormDataMultiSelect,
    WidthModelProperties,
    SelectFundsButton,
    SelectedFundsDropdown,
    RichTextEditableWidget,
};

export default Widgets;
